import styled from "styled-components";
import { Button, Modal, Select, Avatar } from "antd";

// Ana stil
export const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .ant-modal-content {
    width: 343.5px;
    height: 502px;
    padding: 41px 15px 15px 15px;
    border-radius: 8px;
    box-shadow: 0 9px 28px 0 rgba(0, 0, 0, 0.05);
    background-color: #fff;
  }

  .ant-modal-title {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 10px;
    margin-bottom: 20px;
    color: #2d3748;
	border-bottom: 1px solid #eaeaee; // Header altındaki border

  }
`;

// Footer stilleri
export const StyledModalFooter = styled.div`
  display: flex;
  justify-content: flex-end; // Butonları sağa dayalı yapar
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 8px;
  border-top: 1px solid #eaeaee;
  padding-top: 16px;
`;

// Button stilleri
const sharedButtonStyles = `
  width: 110px;
  height: 40px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  margin-right: 8px;
  box-shadow: none;
`;

export const UpdateButton = styled(Button)`
  ${sharedButtonStyles}
  background-color: #4299e1;
`;

export const CloseButton = styled(Button)`
  ${sharedButtonStyles}
  background-color: #8b8b8b;
  color: #ffffff;
`;

// Diğer stiller
export const CustomAvatar = styled(Avatar)`
  margin-right: 8px;
`;

export const CustomOption = styled(Select.Option)`
  border-bottom: 1px solid #e8e8e8;
`;